// extracted by mini-css-extract-plugin
export default {"notfound":"NotFound_notfound__oDF2U","Name":"NotFound_Name__pcfTl"};